/**
 * Modo mantenimiento (solo front).
 * Pon MANTENIMIENTO_ACTIVO en false, rebuild y deploy para reactivar la plataforma.
 */
export const MANTENIMIENTO_ACTIVO = false

export const MANTENIMIENTO_MENSAJE =
  'Estamos actualizando la plataforma. Volveremos en breve. Gracias por tu paciencia.'

export function estaMantenimientoActivo() {
  return MANTENIMIENTO_ACTIVO === true
}
